import { lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { legacyWordPressRouteElements } from '../components/Common/LegacyWordPressRoutes';
import AboutUs from '../components/AboutUs/AboutUs';
import ContactUs from '../components/contactUs/ContactUs';
import FAQ from '../components/FAQs/FAQ';
import AmazonFBAPrep from '../components/AmazonFBA/amazonFBAprep';
import AmazonFBAShipments from '../components/AmazonFBA/Amazonfbashipments';
import ShopifyFulfilment from '../components/ShopifyFulfilment/ShopifyFulfilment';
import SFP from '../components/SFP/SFP';
import TikTokLive from '../components/TiktokLive/TikTokLive';
import TikTokFulfilment from '../components/Tiktok Fulfilment/TikTokFulfilment';
import ReturnHandling from '../components/Return Handling/ReturnHandling';
import MultiChannelFulfilment from '../components/Multichannel Fulfilment/MultiChannelFulfilment';
import MultiChannelIndustryPage from '../components/Multichannel Fulfilment/MultiChannelIndustryPage';
import AmazonFBM from '../components/Fulfilment by Merchant/Amazonfbm';
const Blog = lazy(() => import('../components/Blogs/Blog'));
const BlogDetail = lazy(() => import('../components/Blogs/BlogDetail'));
const SfpVsFba2026 = lazy(() => import('../components/Blogs/SfpVsFba2026'));
import PrivacyPolicy from '../components/PrivacyPolicy/PrivacyPolicy';
import Sitemap from '../components/Sitemap/Sitemap';
import { NotFoundRoute } from '../components/NotFound/NotFound';
import FulfilmentCentreMiltonKeynes from '../components/Local/FulfilmentCentreMiltonKeynes';
import PricingExplainer from '../components/Pricing/PricingExplainer';
import PricingPage from '../components/Pricing/PricingPage';
import FulfilmentCalculatorPage from '../components/Pricing/FulfilmentCalculatorPage';
import OurReviews from '../components/Reviews/OurReviews';
import IntegrationsPage from '../components/Integrations/IntegrationsPage';
import CaseStudiesPage from '../components/CaseStudies/CaseStudiesPage';
import Logistics from '../components/Logistics/Logistics';
import EcommerceFulfillmentServices from '../components/Logistics/EcommerceFulfillmentServices';
import B2BFulfillment from '../components/Logistics/B2BFulfillment';
import WarehousingServices from '../components/Logistics/WarehousingServices';
import FreightForwarderUK from '../components/Logistics/FreightForwarderUK';
import ContractPacking from '../components/Logistics/ContractPacking';
import WMSIntegrations from '../components/Logistics/WMSIntegrations';
import FulfilmentCenter from '../components/FulfilmentCenter/FulfilmentCenter';
import FulfilmentFacilityDetail from '../components/FulfilmentCenter/FulfilmentFacilityDetail';
import PrepCentreServices from '../components/AmazonFBA/Prepcentreservices';
import FbaPrepPricing from '../components/AmazonFBA/Fbapreppricing';
import PrivateLabelFbaPrep from '../components/AmazonFBA/Privatelabelfbaprep';
import WholesaleFbaPrep from '../components/AmazonFBA/Wholesalefbaprep';
import BookAFreeCall from '../components/AmazonFBA/Bookafreecall';
import ThankYou from '../components/ThankYou/ThankYou';
import Careers from '../components/Careers/Careers';
import HomePage from '../components/Homepage/HomePage';
import { AdminAuthOutlet } from '../admin/AdminAuthContext';
import AdminLogin from '../admin/AdminLogin';
import AdminLayout from '../admin/AdminLayout';
import AdminDashboard from '../admin/AdminDashboard';
import AdminBlogList from '../admin/AdminBlogList';
import AdminCommentList from '../admin/AdminCommentList';
import AdminLeads from '../admin/AdminLeads';
import AdminCareers from '../admin/AdminCareers';
import AdminApplications from '../admin/AdminApplications';
import RequireAdminAuth from '../admin/RequireAdminAuth';
import AdminNewsletter from '../admin/AdminNewsletter';

const AdminBlogForm = lazy(() => import('../admin/AdminBlogForm'));

function AdminBlogFormPage() {
  return (
    <Suspense fallback={<div className="admin-loading">Loading editor…</div>}>
      <AdminBlogForm />
    </Suspense>
  );
}

/** Public marketing routes — eager imports so prerender HTML hydrates without Suspense/lazy. */
export default function PublicRoutes() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/about-our-fulfillment-company" element={<AboutUs />} />
      <Route path="/contact-fulfillment-services" element={<ContactUs />} />
      <Route path="/fulfillment-frequently-asked-questions" element={<FAQ />} />
      <Route path="/amazon-fba-prep-services" element={<AmazonFBAPrep />} />
      <Route path="/amazon-fba-prep-centre-services" element={<PrepCentreServices />} />
      <Route path="/amazon-fba-prep-pricing" element={<FbaPrepPricing />} />
      <Route path="/amazon-fba-prep-private-label" element={<PrivateLabelFbaPrep />} />
      <Route path="/amazon-fba-prep-wholesale" element={<WholesaleFbaPrep />} />
      <Route path="/amazon-fba-shipments" element={<AmazonFBAShipments />} />
      <Route path="/shopify-fulfillment-services" element={<ShopifyFulfilment />} />
      <Route path="/logistics-services" element={<Logistics />} />
      <Route path="/ecommerce-fulfillment-services" element={<EcommerceFulfillmentServices />} />
      <Route path="/b2b-fulfillment" element={<B2BFulfillment />} />
      <Route path="/warehousing-services" element={<WarehousingServices />} />
      <Route path="/freight-forwarder-uk" element={<FreightForwarderUK />} />
      <Route path="/contract-packing" element={<ContractPacking />} />
      <Route path="/wms-integrations" element={<WMSIntegrations />} />
      <Route path="/book-a-free-call" element={<BookAFreeCall />} />
      <Route path="/seller-fulfilled-prime-services" element={<SFP />} />
      <Route path="/tiktok-live-sales-fulfillment" element={<TikTokLive />} />
      <Route path="/tiktok-shop-fulfillment-services" element={<TikTokFulfilment />} />
      <Route path="/return-handling-services" element={<ReturnHandling />} />
      <Route path="/multi-channel-fulfillment-services" element={<MultiChannelFulfilment />} />
      <Route path="/beauty-cosmetics-fulfilment-uk" element={<MultiChannelIndustryPage />} />
      <Route path="/fashion-apparel-fulfilment-uk" element={<MultiChannelIndustryPage />} />
      <Route path="/health-supplements-fulfilment-uk" element={<MultiChannelIndustryPage />} />
      <Route path="/electronics-fulfilment-uk" element={<MultiChannelIndustryPage />} />
      <Route path="/food-drink-fulfilment-uk" element={<MultiChannelIndustryPage />} />
      <Route path="/tiktok-brands-fulfilment-uk" element={<MultiChannelIndustryPage />} />
      <Route path="/fulfillment-by-merchant-services" element={<AmazonFBM />} />
      <Route path="/our-fulfilment-center" element={<FulfilmentCenter />} />
      <Route path="/fulfilment-center-services" element={<Navigate to="/our-fulfilment-center" replace />} />
      <Route path="/fulfilment-facility/:slug" element={<FulfilmentFacilityDetail />} />
      <Route path="/fulfillment-blog" element={<Suspense fallback={null}><Blog /></Suspense>} />
      <Route path="/blog/sfp-vs-fba-2026" element={<Suspense fallback={null}><SfpVsFba2026 /></Suspense>} />
      <Route
        path="/blog/sfp-vs-fba-amazon-fulfilment-uk-2026"
        element={<Navigate to="/blog/sfp-vs-fba-2026" replace />}
      />
      <Route path="/blog/:slug" element={<Suspense fallback={null}><BlogDetail /></Suspense>} />
      <Route path="/fulfilment-centre-milton-keynes" element={<FulfilmentCentreMiltonKeynes />} />
      <Route path="/3pl-pricing-explained" element={<PricingExplainer />} />
      <Route path="/pricing-fulfilment-services" element={<PricingPage />} />
      <Route path="/fulfilment-cost-calculator" element={<FulfilmentCalculatorPage />} />
      <Route path="/our-reviews" element={<OurReviews />} />
      <Route path="/integrations" element={<IntegrationsPage />} />
      <Route path="/case-studies" element={<CaseStudiesPage />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/sitemap" element={<Sitemap />} />
      <Route path="/thank-you" element={<ThankYou />} />
      <Route path="/careers" element={<Careers />} />
      <Route path="/admin" element={<AdminAuthOutlet />}>
        <Route path="login" element={<AdminLogin />} />
        <Route
          element={
            <RequireAdminAuth>
              <AdminLayout />
            </RequireAdminAuth>
          }
        >
          <Route index element={<AdminDashboard />} />
          <Route path="inbox" element={<AdminLeads />} />
          <Route path="newsletter" element={<AdminNewsletter />} />
          <Route path="careers" element={<AdminCareers />} />
          <Route path="careers/:id/applications" element={<AdminApplications />} />
          <Route path="blogs" element={<AdminBlogList />} />
          <Route path="comments" element={<AdminCommentList />} />
          <Route path="blogs/new" element={<AdminBlogFormPage />} />
          <Route path="blogs/:id/edit" element={<AdminBlogFormPage />} />
        </Route>
      </Route>
      {legacyWordPressRouteElements()}
      <Route path="*" element={<NotFoundRoute />} />
    </Routes>
  );
}
